module.exports = __webpack_public_path__ + "static/19-b3cf9121ffab0c05936d9d7ea641b904.jpg";